import { render, staticRenderFns } from "./RequestManagement.vue?vue&type=template&id=109aae52&scoped=true"
import script from "./RequestManagement.vue?vue&type=script&lang=js"
export * from "./RequestManagement.vue?vue&type=script&lang=js"
import style0 from "./RequestManagement.vue?vue&type=style&index=0&id=109aae52&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109aae52",
  null
  
)

export default component.exports